import type CopilotPrioritizeSettings from "./CopilotPrioritizeSettings";

const defaultCopilotPrioritizeSettings: CopilotPrioritizeSettings = {
    version: 1,
    prioritizationEnabled: false,
    moreImportantRules: [],
    lessImportantRules: [],
    miscellaneousRules: [],
    applyLowPriorityLabel: false,
    experimentalSetting: null,
    shouldSuggestPrioritization: true,
    replacePreviewWithMicroSummary: true,
    lastPrioritizeNudgeTimestampMs: null,
};

export default defaultCopilotPrioritizeSettings;
